import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import api from "../../../../../api";
import Pagination from "../../../Tools/Pagination";

const AttendanceHistoryModal = ({ show, onClose, empId, formatAttendanceDate }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [dateFormat, setDateFormat] = useState(sessionStorage.getItem("date_format") || "MM/DD/YYYY");
  const [timeFormat, setTimeFormat] = useState(sessionStorage.getItem("time_format") || "12");

  // Fetch system settings for date and time format
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = sessionStorage.getItem("access_token") || "1349|VFSxfHmNSspz9ZhH1Nu9L5yxoD9vlzPoI9BKifiE324f1ef0";
        const res = await api.get("/ems/get-system-setting", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.data?.status === "success" && res.data.data.length > 0) {
          const data = res.data.data[0];
          const newDateFormat = data.date_format || "MM/DD/YYYY";
          const newTimeFormat = data.time_format || "12";
          sessionStorage.setItem("date_format", newDateFormat);
          sessionStorage.setItem("time_format", newTimeFormat);
          setDateFormat(newDateFormat);
          setTimeFormat(newTimeFormat);
        }
      } catch (err) {
        console.error("Error fetching date and time formats:", err);
        // Fallback to defaults if API fails
        sessionStorage.setItem("date_format", "MM/DD/YYYY");
        sessionStorage.setItem("time_format", "12");
        setDateFormat("MM/DD/YYYY");
        setTimeFormat("12");
      }
    };
    fetchSettings();
  }, []);

  // Fetch attendance history
  useEffect(() => {
    if (!show || !empId) return;

    const fetchHistory = async () => {
      try {
        setLoading(true);
        const token = sessionStorage.getItem("access_token") || "1349|VFSxfHmNSspz9ZhH1Nu9L5yxoD9vlzPoI9BKifiE324f1ef0";
        const res = await api.get(`/ems/attendance-history/${empId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setHistory(res.data || []);
      } catch (err) {
        console.error("Error fetching attendance history:", err);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [show, empId]);

  // Format date based on system settings
  const formatDate = (dateString) => {
    try {
      const date = parseISO(dateString);
      const dateFormatMap = {
        "DD/MM/YYYY": "dd/MM/yyyy",
        "MM/DD/YYYY": "MM/dd/yyyy",
        "YYYY-MM-DD": "yyyy-MM-dd",
      };
      const timeFormatString = timeFormat === "12" ? "hh:mm:ss a" : "HH:mm:ss";
      const formatString = `${dateFormatMap[dateFormat] || "MM/dd/yyyy"} ${timeFormatString}`;
      return format(date, formatString);
    } catch (err) {
      console.error("Error formatting date:", err);
      return "Invalid Date";
    }
  };

  // Calculate pagination
  const indexOfLastRecord = currentPage * itemsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - itemsPerPage;
  const currentRecords = history.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalItems = history.length;

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Attendance History</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {loading ? (
              <div className="text-center py-4">Loading history...</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length > 0 ? (
                      currentRecords.map((record, idx) => (
                        <tr key={record.id || idx}>
                          <td>
                            {record.created_at
                              ? formatDate(record.created_at)
                              : "N/A"}
                          </td>
                          <td>
                            {record.today_status === null
                              ? "Not Marked"
                              : record.today_status === 1
                              ? "Present"
                              : "Absent"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center py-4">
                          No history found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <Pagination 
              total={totalItems}
              limit={itemsPerPage}
              page={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-danger" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceHistoryModal;